import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Form, Row, Col, Input, Button, Checkbox, Radio } from 'antd';
import _ from 'lodash';
import Table from 'components/Table';
import organizationRoute from '../../route';

import text from './EmployeeRoleRegister.page.translation';

class FormEmployeeRoleRegister extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempUrl = nextProps.location.pathname.split('/');
    if (tempUrl[tempUrl.length - 1] === 'edit') {
      if (nextProps.formValue !== prevState.formValue) {
        return {
          formValue: nextProps.formValue,
        };
      }
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      formValue: {},
      companyCheckBox: [],
      employeePermission: [
        {
          id: '1',
          section: 'Login',
          permission_name: 'Dashboard',
          permission: false,
          value: 'dashboard',
        },
        {
          id: '2',
          section: 'Login',
          permission_name: 'App',
          permission: false,
          value: 'app',
        },
      ],
      subModuleCheckBox: [],
      flagValidation: {
        employeeRoleName: false,
        employeeRoleDescription: false,
        companyRole: false,
        permission: false,
        subModule: false,
      },
      loadingSubModule: true,
    };
  }

  componentDidUpdate(prevProps) {
    const { allModules } = this.props;
    if (prevProps.allModules !== allModules) {
      this._cduSetState(allModules);
    }
  }

  _cduSetState = allModules => {
    const { formValue } = this.state;
    this._setCompanyRole(allModules);

    const tempUrl = this.props.location.pathname.split('/');
    if (tempUrl[tempUrl.length - 1] === 'edit') {
      const getCompanyRole = [];
      const getSubModule = [];

      const dataModule = _.get(formValue, 'module', '');
      if (dataModule) {
        const getModuleCompanyRole = [dataModule];
        getModuleCompanyRole.forEach(module => {
          const getId = _.get(module, 'id', '');
          const getIdentifier = _.get(module, 'identifier', '');
          getCompanyRole.push(getIdentifier);

          const getScope = _.get(module, 'scopes', '');
          if (getScope) {
            getScope.forEach(scope => {
              getSubModule[`${getId}:${getIdentifier}:${scope}`] = true;
            });
          }
        });
      }

      this._updateListSubModule(getCompanyRole, getSubModule);

      this.props.form.setFieldsValue({
        employeeRoleName: _.get(formValue, 'name', ''),
        employeeRoleDescription: _.get(formValue, 'description', ''),
        companyRole: getCompanyRole[0],
        dashboardCheckbox: _.get(formValue, 'login_dashboard', false),
        appCheckbox: _.get(formValue, 'login_app', false),
      });
    } else {
      this._updateListSubModule([]);
    }
  };

  _updateListSubModule = (moduleSelected, subModule = null) => {
    const { allModules } = this.props;
    const { flagValidation } = this.state;
    const reFormatSubModule = [];

    moduleSelected.forEach(moduleName => {
      let getModule;
      for (let i = 0; i < allModules.length; i += 1) {
        if (allModules[i].identifier === moduleName) {
          getModule = {
            ...allModules[i],
            sub_module: allModules[i].sub_module,
          };
          break;
        }
      }

      if (getModule && getModule.sub_module) {
        const getIndexRole = _.findIndex(getModule.sub_module, [
          'name',
          'Role',
        ]);

        getModule.sub_module.forEach((singleModule, idx, index) => {
          const getSize = index.length;
          // if (moduleName === 'organization') {
          //   getSize = index.length - 1;
          // }

          const startFlag = this._setStartFlag(moduleName, getIndexRole, idx);
          // const getModuleName = _.get(singleModule, 'name', '');

          const permissionCollection = _.map(singleModule.scopes, 'name');
          reFormatSubModule.push({
            idKey: `${getModule.id}${idx}`,
            id: `${getModule.id}`,
            moduleName: getModule.name,
            subModuleName: singleModule.name,
            identifier: getModule.identifier,
            permission: permissionCollection,
            size: getSize,
            startFlag,
          });
        });
      }
    });

    flagValidation.companyRole = false;
    if (subModule) {
      this.setState(
        {
          subModuleCheckBox: reFormatSubModule,
          flagValidation,
        },
        () => {
          this.props.form.setFieldsValue({
            ...subModule,
          });
        },
      );
    } else {
      this.setState({
        subModuleCheckBox: reFormatSubModule,
        flagValidation,
      });
    }
    this.setState({ loadingSubModule: false });
  };

  _setStartFlag = (_moduleName, _getIndexRole, idx) => {
    const startFlag = !idx;
    return startFlag;
  };

  _setCompanyRole = allModules => {
    const getCompanyRoles = [];
    allModules.forEach(module => {
      const disabled = false;
      // if (module.identifier === 'organization') {
      //   disabled = true;
      // }
      getCompanyRoles.push({
        label: module.name,
        value: module.identifier,
        disabled,
      });
    });
    this.setState({
      companyCheckBox: getCompanyRoles,
    });
  };

  _onValidate = (err, formValues) => {
    if (!err) {
      const setModules = [];
      Object.keys(formValues).forEach(key => {
        if (formValues[key] === true && _.includes(key, ':')) {
          const splitKey = key.split(':');
          let reStructureModules;

          const findIndexSetModules = _.findIndex(setModules, [
            'identifier',
            splitKey[1],
          ]);

          if (findIndexSetModules > -1) {
            setModules[findIndexSetModules].scopes.push(
              `${splitKey[2]}:${splitKey[3]}`,
            );
          } else {
            reStructureModules = {
              id: splitKey[0].toString(),
              identifier: splitKey[1].toString(),
              scopes: [`${splitKey[2]}:${splitKey[3]}`],
            };
            setModules.push(reStructureModules);
          }
        }
      });

      let validationCounter = 5;
      validationCounter -= this._checkValidationRoleName(formValues);
      validationCounter -= this._checkValidationRoleDescription(formValues);
      validationCounter -= this._checkValidationCompanyRole(formValues);
      validationCounter -= this._checkValidationPermission(formValues);
      validationCounter -= this._checkValidationSubModule(formValues);

      if (validationCounter === 0) {
        const setResponse = {
          name: _.trim(formValues.employeeRoleName),
          description: _.trim(formValues.employeeRoleDescription),
          module: setModules.length > 0 ? setModules[0] : {},
          login_app: formValues.appCheckbox || false,
          login_dashboard: formValues.dashboardCheckbox || false,
        };

        this.props.onSubmit(setResponse);
      }
    }
  };

  _checkValidationRoleName = formValues => {
    const { flagValidation } = this.state;
    const getRoleName = _.get(formValues, 'employeeRoleName', false);
    if (getRoleName === false || getRoleName === '') {
      flagValidation.employeeRoleName = true;
      this.setState({ flagValidation });
      return 0;
    }
    return 1;
  };

  _checkValidationRoleDescription = formValues => {
    const { flagValidation } = this.state;
    const getRoleName = _.get(formValues, 'employeeRoleDescription', false);
    if (getRoleName === false || getRoleName === '') {
      flagValidation.employeeRoleDescription = true;
      this.setState({ flagValidation });
      return 0;
    }
    return 1;
  };

  _checkValidationCompanyRole = formValues => {
    const { flagValidation } = this.state;
    if (!formValues.companyRole) {
      flagValidation.companyRole = true;
      this.setState({ flagValidation });
      return 0;
    }
    return 1;
  };

  _checkValidationPermission = formValues => {
    const { flagValidation } = this.state;

    if (
      _.get(formValues, 'appCheckbox', false) === false &&
      _.get(formValues, 'dashboardCheckbox', false) === false
    ) {
      flagValidation.permission = true;
      this.setState({ flagValidation });
      return 0;
    }
    return 1;
  };

  _checkValidationSubModule = formValues => {
    const { flagValidation } = this.state;

    const getModuleSelected = [];
    Object.keys(formValues).forEach(key => {
      const splitKey = key.split(':');
      if (formValues[key] === true && splitKey.length > 1) {
        if (getModuleSelected.includes(splitKey[1]) === false)
          getModuleSelected.push(splitKey[1]);
      }
    });

    if (getModuleSelected[0] !== formValues.companyRole) {
      flagValidation.subModule = true;
      this.setState({ flagValidation });
      return 0;
    }
    return 1;
  };

  _handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _onChangeForm = source => {
    const getId = _.get(source, 'target.id', '');
    const { flagValidation } = this.state;

    if (getId === 'employeeRoleName') flagValidation.employeeRoleName = false;
    else if (getId === 'employeeRoleDescription')
      flagValidation.employeeRoleDescription = false;
    else if (getId === 'dashboardCheckbox' || getId === 'appCheckbox')
      flagValidation.permission = false;
    else if (typeof getId === 'string') flagValidation.subModule = false;

    this.setState({ flagValidation });
  };

  _renderEmployeePermissionTable = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const tableColumn = [
      {
        title: formatMessage(text.formLabelSection),
        key: 'index',
        width: '40%',
        align: 'left',
        dataIndex: 'section',
        render: this._renderLabelSection,
      },
      {
        title: formatMessage(text.formLabelPermission),
        dataIndex: 'permission_name',
        width: '40%',
        align: 'left',
      },
      {
        title: formatMessage(text.formLabelAction),
        key: '',
        width: '20%',
        align: 'center',
        render: this._renderLabelAction,
      },
    ];

    return tableColumn;
  };

  _renderLabelSection = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index === 0) obj.props.rowSpan = 2;
    if (index === 1) obj.props.rowSpan = 0;
    return obj;
  };

  _renderLabelAction = value => {
    const { getFieldDecorator } = this.props.form;
    const fieldName = `${value.value}Checkbox`;
    return (
      <Form.Item required colon={false}>
        {getFieldDecorator(fieldName, { valuePropName: 'checked' })(
          <Checkbox onChange={this._onChangeForm}></Checkbox>,
        )}
      </Form.Item>
    );
  };

  _renderSubModuleRoles = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const tableColumn = [
      {
        title: formatMessage(text.formLabelModule),
        width: '25%',
        key: 'idKey',
        align: 'left',
        dataIndex: 'moduleName',
        render: this._renderModulName,
      },
      {
        title: formatMessage(text.formLabelSubModule),
        width: '25%',
        align: 'left',
        dataIndex: 'subModuleName',
      },
      {
        title: formatMessage(text.formLabelPermission),
        className: 'bbottom',
        children: [
          this._childrenColumn('create'),
          this._childrenColumn('read'),
          this._childrenColumn('update'),
          this._childrenColumn('delete'),
        ],
      },
    ];

    return tableColumn;
  };

  _renderModulName = (value, row) => {
    const obj = {
      children: value,
      props: {},
    };

    if (row.startFlag) {
      obj.props.rowSpan = row.size;
    } else {
      obj.props.rowSpan = 0;
    }

    return obj;
  };

  _childrenColumn = key => {
    const {
      intl: { formatMessage },
    } = this.props;
    const getLabel = `formLabel${_.capitalize(key)}`;
    return {
      title: formatMessage(text[getLabel]),
      width: '12.5%',
      key,
      align: 'center',
      render: this._renderChildrenColumn(key),
    };
  };

  _renderChildrenColumn = key => value => {
    const { getFieldDecorator } = this.props.form;
    const fieldName = `${value.id}:${value.identifier}:${value.subModuleName}:${key}`;
    const disabled = !value.permission.includes(key);
    return (
      <Form.Item required colon={false}>
        {getFieldDecorator(fieldName, { valuePropName: 'checked' })(
          <Checkbox
            onChange={this._onChangeForm}
            disabled={disabled}
          ></Checkbox>,
        )}
      </Form.Item>
    );
  };

  _getRowIdKey = row => row.idKey;

  _getRowId = row => row.id;

  _renderValidation = message => (
    <span className="validation-alert-style">{message}</span>
  );

  _renderForm = () => {
    const { getFieldDecorator } = this.props.form;
    const {
      intl: { formatMessage },
    } = this.props;
    const { companyCheckBox, flagValidation, loadingSubModule } = this.state;

    const validationEmployeeRoleText = formatMessage(
      text.formRequiredEmployeeRoleName,
    );
    const validationEmployeeRoleDescription = formatMessage(
      text.formRequiredEmployeeRoleDescription,
    );
    const validationCompanyRoleText = formatMessage(text.validationCompanyRole);

    return (
      <div className="form-wrapper">
        <Row gutter={24} className="mbottom30">
          <Col span={10}>
            <Form.Item
              label={formatMessage(text.formLabelEmployeeRoleName)}
              required
              colon={false}
            >
              {getFieldDecorator('employeeRoleName', {})(
                <Input
                  placeholder={formatMessage(
                    text.formPlaceholderEmployeeRoleName,
                  )}
                  size="large"
                  onChange={this._onChangeForm}
                />,
              )}
            </Form.Item>
            {flagValidation.employeeRoleName
              ? this._renderValidation(validationEmployeeRoleText)
              : null}
          </Col>
        </Row>

        <Row gutter={24} className="mbottom30">
          <Col span={10}>
            <Form.Item
              label={formatMessage(text.formLabelEmployeeRoleDescription)}
              required
              colon={false}
            >
              {getFieldDecorator('employeeRoleDescription', {})(
                <Input.TextArea
                  rows={4}
                  placeholder={formatMessage(
                    text.formPlaceholderEmployeeRoleDescription,
                  )}
                  size="large"
                  onChange={this._onChangeForm}
                />,
              )}
            </Form.Item>
            {flagValidation.employeeRoleDescription
              ? this._renderValidation(validationEmployeeRoleDescription)
              : null}
          </Col>
        </Row>

        <Row gutter={24} className="mbottom30">
          <Col span={24}>
            <div className="field">
              <Form.Item
                label={formatMessage(text.formLabelCompanyRoles)}
                colon={false}
              >
                {getFieldDecorator('companyRole', {
                  // initialValue: ['organization'],
                })(
                  <Radio.Group
                    className="company-checkbox-group"
                    options={companyCheckBox}
                    onChange={e => {
                      this._updateListSubModule([e.target.value]);
                    }}
                  />,
                )}
              </Form.Item>
              {flagValidation.companyRole
                ? this._renderValidation(validationCompanyRoleText)
                : null}
            </div>
          </Col>
        </Row>

        <Row gutter={24} className="mbottom30">
          <Col span={14}>
            <label className="label-style">
              {formatMessage(text.formLabelEmployeePermission)}
            </label>
            <Table
              rowID={this._getRowId}
              columns={this._renderEmployeePermissionTable()}
              dataSource={this.state.employeePermission}
              rowClass="striped-table"
              pagination=""
            />
            {flagValidation.permission
              ? this._renderValidation(formatMessage(text.validationPermission))
              : null}
          </Col>
        </Row>

        <Row gutter={24} className="mbottom30">
          <Col span={24}>
            <Table
              rowID={this._getRowIdKey}
              columns={this._renderSubModuleRoles()}
              dataSource={this.state.subModuleCheckBox}
              rowClass="striped-table"
              pagination=""
              emptyText="Select company roles first"
              customEmptyText
              loadingValue={loadingSubModule}
            />
            {flagValidation.subModule
              ? this._renderValidation(formatMessage(text.validationSubModule))
              : null}
          </Col>
        </Row>
      </div>
    );
  };

  _renderBtn = () => {
    const { btnText } = this.props;

    return (
      <div className="btn-wrapper">
        <Link to={organizationRoute.EMPLOYEE_ROLE_LIST}>
          <Button type="default" block className="btn back-btn">
            Back
          </Button>
        </Link>

        <Button
          type="primary"
          block
          className="btn save-btn"
          htmlType="submit"
          loading={this.props.isFetching}
        >
          {btnText}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <div>
        <Form onSubmit={this._handleSubmit}>
          {this._renderForm()}
          {this._renderBtn()}
        </Form>
      </div>
    );
  }
}

FormEmployeeRoleRegister.propTypes = {
  form: PropTypes.object,
  formValue: PropTypes.object,
  btnText: PropTypes.string,
  location: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  isFetching: PropTypes.bool,
  allModules: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
};

export default FormEmployeeRoleRegister;
